/**
 * Utilities for ordering subcourse levels (CEFR, JLPT, etc.)
 */

export const JLPT_LEVEL_ORDER = ['N5', 'N4', 'N3', 'N2', 'N1'];
export const CEFR_LEVEL_ORDER = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];

export const parseSubcourseOrder = (raw) => {
  if (typeof raw === 'number' && !Number.isNaN(raw)) return raw;
  if (typeof raw === 'string' && raw.trim() !== '') {
    const parsed = Number(raw);
    if (!Number.isNaN(parsed)) return parsed;
  }
  return null;
};

export const getLevelSequence = (levelSort, defaultLevels = []) => {
  if (defaultLevels?.length) {
    return defaultLevels.map((level) => level.toUpperCase());
  }
  return levelSort === 'jlpt' ? JLPT_LEVEL_ORDER : CEFR_LEVEL_ORDER;
};

export const getLevelSortIndex = (code, levelSort, defaultLevels = []) => {
  if (!code) return Number.MAX_SAFE_INTEGER;
  const normalized = code.toString().toUpperCase();
  const sequence = getLevelSequence(levelSort, defaultLevels);
  const idx = sequence.indexOf(normalized);
  return idx >= 0 ? idx : Number.MAX_SAFE_INTEGER;
};

export const compareSubcourseLevels = (a, b, { levelSort = 'cefr', defaultLevels = [] } = {}) => {
  const orderA = parseSubcourseOrder(a.order);
  const orderB = parseSubcourseOrder(b.order);

  if (orderA !== null && orderB !== null && orderA !== orderB) {
    return orderA - orderB;
  }

  const indexA = getLevelSortIndex(a.code, levelSort, defaultLevels);
  const indexB = getLevelSortIndex(b.code, levelSort, defaultLevels);
  if (indexA !== indexB) return indexA - indexB;

  return (a.code || '').localeCompare(b.code || '');
};

export const compareSubcourseKeys = (keyA, keyB, levelSort = 'cefr') => {
  const sequence = getLevelSequence(levelSort).map((level) => level.toLowerCase());
  const normalizedA = (keyA || '').toLowerCase();
  const normalizedB = (keyB || '').toLowerCase();
  const idxA = sequence.indexOf(normalizedA);
  const idxB = sequence.indexOf(normalizedB);
  if (idxA >= 0 && idxB >= 0) return idxA - idxB;
  if (idxA >= 0) return -1;
  if (idxB >= 0) return 1;
  return normalizedA.localeCompare(normalizedB);
};

export const parseSortColumn = (sortColumn) => {
  if (!sortColumn) return { subcourse: null, type: null };
  const lastDash = sortColumn.lastIndexOf('-');
  if (lastDash <= 0) return { subcourse: sortColumn, type: null };
  return {
    subcourse: sortColumn.slice(0, lastDash),
    type: sortColumn.slice(lastDash + 1),
  };
};

export const resolveLevelSortFromLangCode = (langCode) => {
  if (langCode === 'ja') return 'jlpt';
  return 'cefr';
};
